export const EXPORT_SECTIONS = [
  {
    id: 'datosPersonales',
    label: 'Datos personales',
    fields: [
      { id: 'grupo',            label: 'Grupo actividad' },
      { id: 'apellidos',        label: 'Apellidos' },
      { id: 'nombre',           label: 'Nombre' },
      { id: 'telefono',         label: 'Teléfono' },
      { id: 'sexo',             label: 'Sexo' },
      { id: 'fechaNacimiento',  label: 'Fecha nacimiento' },
      { id: 'edad',             label: 'Edad' },
      { id: 'viven',            label: 'Vive con' },
      { id: 'nivelEducacional', label: 'Nivel educacional' },
    ],
  },
  {
    id: 'entrevista',
    label: 'Entrevista',
    prePost: true,
    fields: [
      { id: 'fumador',        label: 'Fumador' },
      { id: 'alcohol',        label: 'Alcohol' },
      { id: 'numAnalgesicos', label: 'Nº analgésicos' },
      { id: 'numCaidas',      label: 'Nº caídas' },
      { id: 'tensionPAS',     label: 'Tensión PAS' },
      { id: 'tensionPAD',     label: 'Tensión PAD' },
      { id: 'tensionPMM',     label: 'Tensión PMM' },
      { id: 'medicacion',     label: 'Resumen medicación' },
      { id: 'numPastillas',   label: 'Nº pastillas (POST)' },
      { id: 'caidasFinales',  label: 'Caídas finales (POST)' },
      { id: 'datosInteres',   label: 'Datos de interés' },
    ],
  },
  {
    id: 'medidas',
    label: 'Medidas antropométricas',
    prePost: true,
    fields: [
      { id: 'talla',                  label: 'Talla' },
      { id: 'peso',                   label: 'Peso' },
      { id: 'imc',                    label: 'IMC' },
      { id: 'perimetroAbdominal',     label: 'Perímetro abdominal' },
      { id: 'grasa',                  label: 'Grasa (%)' },
      { id: 'nivelGrasa',             label: 'Nivel grasa visceral' },
      { id: 'pesoBrazosPiernas',      label: 'Peso brazos y piernas' },
      { id: 'almAltura2',             label: 'ALM/Altura²' },
    ],
  },
  {
    id: 'capacidadFuncional',
    label: 'Capacidad funcional (SPPB)',
    prePost: true,
    fields: [
      { id: 'puntosBalance',        label: 'Puntos equilibrio' },
      { id: 'tiempoTandem',         label: 'Tiempo tandem (s)' },
      { id: 'puntosMarcha',         label: 'Puntos marcha' },
      { id: 'tiempoDesplazamiento', label: 'Tiempo desplazamiento (s)' },
      { id: 'velocidadMarcha',      label: 'Velocidad marcha (m/s)' },
      { id: 'puntosSilla',          label: 'Puntos silla' },
      { id: 'sentadillas',          label: 'Sentadillas (s)' },
      { id: 'puntosSPPB',           label: 'Puntos SPPB' },
      { id: 'fragilidadSPPB',       label: 'Fragilidad SPPB' },
      { id: 'tug',                  label: 'TUG (s)' },
      { id: 'fragilidadTUG',        label: 'Fragilidad TUG' },
    ],
  },
  {
    id: 'valoracionFuncional',
    label: 'Valoración funcional',
    prePost: true,
    fields: [
      { id: 'mediaDerecha',    label: 'Media derecha' },
      { id: 'mediaIzquierda',  label: 'Media izquierda' },
      { id: 'dsDerecha',       label: 'DS derecha' },
      { id: 'dsIzquierda',     label: 'DS izquierda' },
    ],
  },
  {
    id: 'encoder',
    label: 'Encoder',
    prePost: true,
    fields: [
      { id: 'velocidad',  label: 'Velocidad media (m/s)' },
      { id: 'tiempo5STS', label: 'Tiempo 5STS (s)' },
      { id: 'potencia',   label: 'Potencia (w)' },
      { id: 'distancia',  label: 'Distancia recorrida (cm)' },
    ],
  },
];

export const DEFAULT_SELECTION = Object.fromEntries(
  EXPORT_SECTIONS.map((section) => [
    section.id,
    Object.fromEntries(section.fields.map((f) => [f.id, true])),
  ])
);

export const EXPORT_MODES = [
  { value: 'comparison', label: 'Comparativa PRE / POST' },
  { value: 'pre',        label: 'Solo PRE' },
  { value: 'post',       label: 'Solo POST' },
];

const PRESETS_KEY = 'exportPresets';

export const loadPresets = () => {
  try {
    return JSON.parse(localStorage.getItem(PRESETS_KEY) || '[]');
  } catch {
    return [];
  }
};

export const savePreset = (name, config) => {
  const presets = loadPresets();
  const existing = presets.findIndex((p) => p.name === name);
  if (existing >= 0) {
    presets[existing] = { name, config };
  } else {
    presets.push({ name, config });
  }
  localStorage.setItem(PRESETS_KEY, JSON.stringify(presets));
  return presets;
};

export const deletePreset = (name) => {
  const presets = loadPresets().filter((p) => p.name !== name);
  localStorage.setItem(PRESETS_KEY, JSON.stringify(presets));
  return presets;
};
